module.exports = __webpack_public_path__ + "img/catalog.5fc6ffb6.svg";